import type React from 'react';

import type { WithDataTestid } from '@vlabs/uikit/types';
import classNames from 'classnames';

import st from './TypeCard.module.sass';

interface TypeCardProps extends WithDataTestid {
  title: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  disabled?: boolean;
  onClick?: VoidFunction;
  className?: string;
}

function TypeCard({
  title,
  description = undefined,
  icon = undefined,
  disabled = false,
  onClick = undefined,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: TypeCardProps): React.JSX.Element {
  return (
    <button
      className={classNames(st.Root, className)}
      data-testid={dataTestId}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {icon !== undefined && icon !== null && <span className={st.Icon}>{icon}</span>}
      <span className={st.Title}>{title}</span>
      {description !== undefined && description !== null && (
        <span className={st.Description}>{description}</span>
      )}
    </button>
  );
}

export { TypeCard };
export type { TypeCardProps };
